export default id => "INV-" + id.toString().padStart(5, "0");
